import { render, staticRenderFns } from "./ButtonAnimation.vue?vue&type=template&id=4b03dee7&lang=pug"
import script from "./ButtonAnimation.vue?vue&type=script&lang=js"
export * from "./ButtonAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports